// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:30
import { MapIcon_abstract } from './../../abstract/SagaBase/Objects/MapIcon_abstract';
export class MapIcon extends MapIcon_abstract {}
